import { Spinner } from '@/shared/ui/Spinner';

export function PageLoader() {
  return (
    <div className="flex-center bg-backdrop fixed inset-0 z-50">
      <Spinner />
    </div>
  );
}
